
import { IKhoaReducer } from "../../reducer-model/category/IKhoaReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKhoaActionTypes } from "../../action-types/category/IKhoaActions";
const iniState: IKhoaReducer = {
  status: eReducerStatusBase.is_not_initialization,
  khoas: [],
};
export const khoaReducer = (
  state: IKhoaReducer = iniState,
  action: IKhoaActionTypes
): IKhoaReducer => {
  switch (action.type) {
    case "KHOA_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KHOA_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        khoas: action.payload,
      };
    case "KHOA_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KHOA_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        khoaEditing: action.payload
      };
    case "KHOA_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "KHOA_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "KHOA_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal:false
      };
    case "KHOA_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KHOA_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "KHOA_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "KHOA_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
